import "./AboutMe.module.css";
import Header from "@/reusable_sections/Header";
import Trajectory from "./sections/Trajectory";
import Footer from "@/reusable_sections/Footer";
export default function AboutMePage() {
  return <div>
      <Header />
      <Trajectory />
      <Footer />
    </div>;
}